interface IToggleSwitchProps {
  id: string;
  name?: string;
  checked: boolean;
  onChange: (event: boolean) => void;
  on: string;
  off: string;
  small?: boolean;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<IToggleSwitchProps> = ({
  id,
  name,
  checked = true,
  onChange,
  on,
  off,
  small,
  disabled,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.keyCode !== 32) return;

    e.preventDefault();
    onChange(!checked);
  };

  return (
    <>
      <div className={`toggle-switch ${small ? ' small-switch' : ''}`}>
        <input
          type="checkbox"
          name={name}
          className="toggle-switch-checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          data-testid="ToggleSwitch-input-checkbox-1"
        />
        {id ? (
          <label
            className="toggle-switch-label"
            tabIndex={disabled ? -1 : 1}
            onKeyDown={(e) => handleKeyPress(e)}
            htmlFor={id}
          >
            <span
              className={
                disabled
                  ? 'toggle-switch-inner toggle-switch-disabled'
                  : 'toggle-switch-inner'
              }
              data-on={on}
              data-off={off}
              tabIndex={-1}
            />
            <span
              className={
                disabled
                  ? 'toggle-switch-switch toggle-switch-disabled'
                  : 'toggle-switch-switch'
              }
              tabIndex={-1}
            />
          </label>
        ) : null}
      </div>
      <style jsx>{`
        .toggle-switch {
          position: relative;
          width: 112px;
          display: inline-block;
          vertical-align: middle;
          text-align: left;
        }

        .toggle-switch-checkbox {
          display: none;
        }

        .toggle-switch-label {
          display: block;
          overflow: hidden;
          cursor: pointer;
          border: 0 solid #bbb;
          border-radius: 20px;
          margin: 0;
        }

        .toggle-switch-label:focus {
          outline: none;
        }

        .toggle-switch-label:focus > span {
          box-shadow: 0 0 2px 5px red;
        }

        .toggle-switch-label > span:focus {
          outline: none;
        }

        .toggle-switch-inner {
          display: block;
          width: 200%;
          margin-left: ${!checked ? `-100%` : `0`};
          transition: margin 0.3s ease-in 0s;
        }

        .toggle-switch-inner:before,
        .toggle-switch-inner:after {
          display: block;
          float: left;
          width: 50%;
          height: 40px;
          padding: 0;
          line-height: 40px;
          font-size: var(--font-size-2);
          box-sizing: border-box;
          text-align: center;
        }

        .toggle-switch-inner:before {
          content: attr(data-on);
          text-transform: uppercase;
          background-color: var(--clr-primary-1);
        }

        .toggle-switch-disabled {
          background-color: #ddd;
          cursor: not-allowed;
        }

        .toggle-switch-disabled:before {
          background-color: #ddd;
          cursor: not-allowed;
        }

        .toggle-switch-inner:after {
          content: attr(data-off);
          text-transform: uppercase;
          background-color: #bbb;
        }

        .toggle-switch-switch {
          display: block;
          width: 34px;
          height: 34px;
          background: var(--white);
          position: absolute;
          margin: 3px;
          top: 0;
          bottom: 0;
          right: ${!checked ? `72px` : `0`};
          border: 0 solid #bbb;
          border-radius: 34px;
          transition: all 0.3s ease-in 0s;
        }

        .toggle-switch.small-switch {
          width: 40px;
        }

        .toggle-switch.small-switch .toggle-switch-inner:after,
        .toggle-switch.small-switch .toggle-switch-inner:before {
          content: '';
          height: 20px;
          line-height: 20px;
        }

        .toggle-switch.small-switch .toggle-switch-switch {
          width: 16px;
          right: 20px;
          margin: 2px;
        }
      `}</style>
    </>
  );
};

export default ToggleSwitch;
